/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 11/20/15.
 */
'use strict';
angular.module('prism-ui.package').controller('CreateClipModalController',function($uibModalInstance) {
	var self = this;

	self.numberOfClips = 1;
	self.maxClips = 99;

	self.onNumDraftClipsChanged = function (numDraftClips) {
		if (numDraftClips > self.maxClips) {
			self.numberOfClips = self.maxClips;
		} else if (isNaN(numDraftClips) || numDraftClips === 0) {
			self.numberOfClips = 1;
		} else {
			self.numberOfClips = numDraftClips;
		}
	};

	self.onOk = function () {
		$uibModalInstance.close({title: self.clipTitle, numberOfClips: self.numberOfClips});
	};

	self.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	};
});
